module.exports = __webpack_public_path__ + "img/background4.5f9f7843.jpg";